export type USER_TYPE = 'SUPER_ADMIN' | 'CONSULTANT' | 'DISABLED' | '';

// export type QUESTION_TYPE =
//   | 'POINTS'
//   | 'INPUT'
//   | 'NUMERIC'
//   | 'MULTIPLE_INPUT'
//   | 'BOOLEAN';

export enum QUESTION_TYPE {
  Points = 'POINTS',
  Input = 'INPUT',
  Numeric = 'NUMERIC',
  MultipleInput = 'MULTIPLE_INPUT',
  Booblean = 'BOOLEAN',
};
